// The picture of Australian coins and notes. Plain React SVG, like
// practice-graphs.tsx.
//
// Each piece carries its value, so the child can count the money; the
// total is never shown.

import {
  describeMoney,
  moneyPicture,
  type MoneySpec,
} from './practice-money-data';

const INK = '#2d4a3e';

export function MoneyPictureView({ money }: { money: MoneySpec }) {
  const picture = moneyPicture(money);

  return (
    <figure className="m-0 max-w-md">
      <svg
        role="img"
        aria-label={describeMoney(money)}
        viewBox={`0 0 ${String(picture.width)} ${String(picture.height)}`}
        className="mx-auto block h-auto w-full"
        style={{ maxWidth: `${String(Math.round(picture.width * 1.3))}px` }}
      >
        {picture.pieces.map((piece, index) => {
          const cx = piece.x + piece.width / 2;
          const cy = piece.y + piece.height / 2;
          if (piece.kind === 'note') {
            return (
              <g key={index} data-note={piece.value}>
                <rect
                  x={piece.x}
                  y={piece.y}
                  width={piece.width}
                  height={piece.height}
                  rx="6"
                  fill={piece.fill}
                  stroke={INK}
                  strokeWidth="1.5"
                />
                <rect
                  x={piece.x + 5}
                  y={piece.y + 5}
                  width={piece.width - 10}
                  height={piece.height - 10}
                  rx="3"
                  fill="none"
                  stroke={INK}
                  strokeOpacity="0.35"
                />
                <text
                  x={cx}
                  y={cy}
                  dy="0.35em"
                  textAnchor="middle"
                  fill={INK}
                  fontSize="18"
                  fontWeight="700"
                >
                  {piece.value}
                </text>
              </g>
            );
          }
          const radius = piece.width / 2;
          return (
            <g key={index} data-coin={piece.value}>
              {piece.corners === null ? (
                <circle
                  cx={cx}
                  cy={cy}
                  r={radius}
                  fill={piece.fill}
                  stroke={INK}
                  strokeWidth="1.5"
                />
              ) : (
                <polygon
                  points={piece.corners}
                  fill={piece.fill}
                  stroke={INK}
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
              )}
              <circle
                cx={cx}
                cy={cy}
                r={radius - 3.5}
                fill="none"
                stroke={INK}
                strokeOpacity="0.3"
              />
              <text
                x={cx}
                y={cy}
                dy="0.35em"
                textAnchor="middle"
                fill={INK}
                fontSize={Math.max(10, Math.round(radius * 0.62))}
                fontWeight="700"
              >
                {piece.value}
              </text>
            </g>
          );
        })}
      </svg>
    </figure>
  );
}
